import { render, staticRenderFns } from "./CommunityRight.vue?vue&type=template&id=5f7c9828&scoped=true&"
import script from "./CommunityRight.vue?vue&type=script&lang=js&"
export * from "./CommunityRight.vue?vue&type=script&lang=js&"
import style0 from "./CommunityRight.vue?vue&type=style&index=0&id=5f7c9828&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7c9828",
  null
  
)

export default component.exports